module.exports = __webpack_public_path__ + "img/album18_28.00f89e51.jpg";